exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".masonry-grid[data-v-5ae78320] {\n  display: grid;\n  grid-gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  grid-auto-flow: dense;\n  padding-right: 22px;\n  padding-bottom: 40px;\n  margin-right: 75px;\n  width: 100%;\n}\n@media screen and (max-width: 1200px) {\n.masonry-grid[data-v-5ae78320] {\n    display: flex;\n    flex-direction: column;\n    row-gap: 16px;\n}\n}", ""]);

// exports
